import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetAccountDetail = () => {
	const navigate = useNavigate()
	const {idx} = useParams()
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/account/${idx}/detail`

		fetchRequest('GET', url)
	}, [])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'account_idx')
					setAlert('사용자 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('사용자 데이터가 존재하지 않습니다.')
					navigate('/user')
				}
				break
		}
	}, [fetchResult])

	return [fetchResult]
}

export default useGetAccountDetail
